import { useState } from "react";
import { NameAndPassword } from "./NameAndPassword";

export const UserOnboarding = (props) => {
  const [slide, setSlide] = useState(0);

  return <NameAndPassword {...props} />;
};
